<template>
  <generic-modal
    :title="$t('archive.expedient')"
    :buttons="buttons"
    ref="generic_modal"
  >
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <div class="control">
              <generic-dropdown
                :title="$t('archive.customer')"
                :placeholder="$t('archive.select_customer')"
                :is_multiple="false"
                url="/archive/customer/catalog"
                name_field="name"
                value_field="customer_id"
                @selected="customer_selected"
                ref="customer_dropdown"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <div class="control">
              <generic-dropdown
                :title="$t('archive.expedient_type')"
                :placeholder="$t('archive.select_expedient_type')"
                :is_multiple="false"
                url="/archive/expedient-type/catalog"
                name_field="name"
                value_field="expedient_type_id"
                @selected="expedient_type_selected"
                ref="expedient_type_dropdown"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("archive.expedient_number") }} *</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.expedient_number"
                :placeholder="$t('archive.expedient_number')"
                maxlength="50"
                required
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("archive.expedient_name") }} *</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.name"
                :placeholder="$t('archive.expedient_name')"
                maxlength="255"
                required
              />
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("archive.description") }}</label>
            <div class="control">
              <textarea
                class="textarea"
                v-model="meta.description"
                :placeholder="$t('archive.description')"
                rows="3"
                maxlength="1000"
              >
              </textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("archive.status") }}</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="meta.status">
                  <option value="active">
                    {{ $t("archive.status_active") }}
                  </option>
                  <option value="pending">
                    {{ $t("archive.status_pending") }}
                  </option>
                  <option value="closed">
                    {{ $t("archive.status_closed") }}
                  </option>
                  <option value="archived">
                    {{ $t("archive.status_archived") }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("archive.priority") }}</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="meta.priority">
                  <option value="low">{{ $t("archive.priority_low") }}</option>
                  <option value="medium">
                    {{ $t("archive.priority_medium") }}
                  </option>
                  <option value="high">
                    {{ $t("archive.priority_high") }}
                  </option>
                  <option value="urgent">
                    {{ $t("archive.priority_urgent") }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("archive.notes") }}</label>
            <div class="control">
              <textarea
                class="textarea"
                v-model="meta.notes"
                :placeholder="$t('archive.notes')"
                rows="3"
                maxlength="2000"
              >
              </textarea>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
  </generic-modal>
</template>

<script>
import {
  put,
  error_message,
  get,
  post,
  del,
  error_alert,
  api_host,
  generate_error_message_text,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "ExpedientModal",
  components: {
    GenericModal,
    GenericDropdown,
  },
  data() {
    return {
      api_host,
      buttons: [
        {
          text: this.$t("save"),
          class: "is-primary is-rounded",
          icon: "fa fa-save",
          click: this.save,
          disabled: "this.is_form_invalid",
        },
        {
          text: this.$t("delete"),
          class: "is-danger is-rounded",
          icon: "fa fa-trash",
          click: this.delete_expedient,
          visible:
            "this.meta.expedient_id && (!this.meta.file_count || this.meta.file_count === 0)",
        },
        {
          text: this.$t("close"),
          class: "is-rounded",
          icon: "fa fa-close",
          click: this.close_modal,
        },
      ],
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      return !v.meta.customer_id || !v.meta.expedient_number || !v.meta.name;
    },
  },
  methods: {
    customer_selected(customer) {
      let v = this;
      if (customer) v.meta.customer_id = customer.customer_id;
    },
    expedient_type_selected(expedient_type) {
      let v = this;
      if (expedient_type)
        v.meta.expedient_type_id = expedient_type.expedient_type_id;
    },
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(uuid) {
      let v = this;
      v.set_initial_state();

      if (uuid) {
        get("/archive/expedient", { uuid })
          .then((expedient) => {
            v.meta = expedient;
            // Set the customer in the dropdown
            if (expedient.customer_id && v.$refs.customer_dropdown) {
              v.$refs.customer_dropdown.set_value(expedient.customer_id);
            }
            // // Set the expedient type in the dropdown
            if (
              expedient.expedient_type_id &&
              v.$refs.expedient_type_dropdown
            ) {
              v.$refs.expedient_type_dropdown.set_value(
                expedient.expedient_type_id
              );
            }
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }

      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let data = { ...v.meta };

      if (!v.meta.expedient_id) {
        put("/archive/expedient", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        post("/archive/expedient", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    delete_expedient() {
      let v = this;
      if (!v.meta.expedient_id) return;

      if (!confirm(v.$t("archive.confirm_delete_expedient"))) {
        return;
      }

      del("/archive/expedient", { expedient_id: v.meta.expedient_id })
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        expedient_id: null,
        customer_id: "",
        expedient_number: "",
        name: "",
        description: "",
        status: "active",
        priority: "medium",
        notes: "",
        file_count: 0,
      };
      v.error = "";
      // Clear the customer dropdown
      if (v.$refs.customer_dropdown) {
        v.$refs.customer_dropdown.clear();
      }
    },
  },
  watch: {
    is_form_invalid() {
      let v = this;
      v.buttons[0].disabled = v.is_form_invalid;
    },
  },
};
</script>

<style>
.field {
  margin-bottom: 1rem;
}

.textarea {
  resize: vertical;
  min-height: 80px;
}
</style>
